import React from 'react';
import { useIntl } from 'react-intl';
import clsx from 'clsx';
import { TypedMemo } from '../../../common/types';
import { footageMessages } from '../../messages/footageMessages';
/* eslint-disable css-modules/no-unused-class -- the editor stylesheet; this part uses its own slice of it */
import editorStyles from '../../MusicVideoEditor.module.scss';
/* eslint-enable css-modules/no-unused-class */
/* eslint-disable css-modules/no-unused-class -- one stylesheet for these parts of the editor; each part uses its own slice of it */
import styles from './ReferencePicker.module.scss';
/* eslint-enable css-modules/no-unused-class */

/** The longest style text of the form (the API keeps 1000 characters). */
export const AI_STYLE_TEXT_MAX_LENGTH = 1000;

type AiStyleControlProps =
  | {
      /** A cut that a directed video made (design i1): a switch with the style of the video. */
      kind: 'directed';
      directedStyleText: string;
      isOn: boolean;
      onToggle: () => void;
      disabled: boolean;
    }
  | {
      /** Any other cut with a cast library (design i3): a free style text. */
      kind: 'text';
      value: string;
      onChange: (value: string) => void;
      disabled: boolean;
    };

/** The style of a new AI shot: the switch of a directed cut, or an optional style text. */
const AiStyleControlComponent: React.FC<AiStyleControlProps> = (props) => {
  const intl = useIntl();
  const { disabled } = props;
  // `in` narrows the union: only the directed variant has `isOn`.
  if ('isOn' in props) {
    const { isOn, onToggle, directedStyleText } = props;
    return (
      <div className={styles.styleRow}>
        <button
          type="button"
          role="switch"
          aria-checked={isOn}
          aria-label={intl.formatMessage(footageMessages.styleSwitch)}
          disabled={disabled}
          className={clsx(editorStyles.toggle, isOn && editorStyles.toggleOn)}
          onClick={onToggle}
        />
        <div className={styles.styleText}>
          <b>{intl.formatMessage(footageMessages.styleSwitch)}</b>
          <span className={editorStyles.hint}>{directedStyleText}</span>
        </div>
      </div>
    );
  }
  const { value, onChange } = props;
  return (
    <>
      <span className={editorStyles.eyebrow}>{intl.formatMessage(footageMessages.styleText)}</span>
      <textarea
        className={editorStyles.textArea}
        value={value}
        maxLength={AI_STYLE_TEXT_MAX_LENGTH}
        placeholder={intl.formatMessage(footageMessages.styleTextPlaceholder)}
        aria-label={intl.formatMessage(footageMessages.styleText)}
        disabled={disabled}
        onChange={(event) => onChange(event.target.value)}
      />
    </>
  );
};

export const AiStyleControl = TypedMemo(AiStyleControlComponent);
